import axios from "axios";

export const feedServer = axios.create({
    baseURL: "http://localhost:8000/",
    headers: {
        "Content-type": "application/json"
    }
});

export const authServer = axios.create({
    baseURL: "http://localhost:3009/",
    headers: {
        "Content-type": "application/json"
    }
});

export const friendServer = axios.create({
    baseURL: "http://localhost:5000/",
    headers: {
        "Content-type": "application/json"
    }
});
